import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

// Initialize recoil-persist
const { persistAtom } = recoilPersist({
  key: 'recoil-persist-global',
  storage: localStorage,
});

// Global UI state atoms
export const isDrawerOpenAtom = atom<boolean>({
  key: 'isDrawerOpen',
  default: false,
});

export const isLeftPanelOpenAtom = atom<boolean>({
  key: 'isLeftPanelOpen',
  default: true,
});

// Persisted global atoms
export const activeMarketFromStorageAtom = atom<string>({
  key: 'activeMarketFromStorage',
  default: '',
  effects_UNSTABLE: [persistAtom],
});

export const darkModeAtom = atom<boolean>({
  key: 'darkMode',
  default: true,
  effects_UNSTABLE: [persistAtom],
});

export const exoticModeAtom = atom<boolean>({
  key: 'exoticMode',
  default: false,
});

export const cexSocketConnectedAtom = atom<boolean>({
  key: 'cexSocketConnected',
  default: false,
});
